var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("organization-profile-home"),
      _vm._v(" "),
      _c("events-home"),
      _vm._v(" "),
      _c("resources-home"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }